<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('beacons')">
          Beacons
        </inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.name }}
      </h1>
      <!--      <img v-if="beacon.photo" class="block w-8 h-8 rounded-full ml-4" :src="beacon.photo" alt="Photo" />-->
    </div>
    <trashed-message v-if="beacon.deleted_at" class="mb-6" @restore="restore">
      Este beacon foi excluído.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-if="showOrganizations" v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full" label="Organização">
            <option :value="null" />
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
          </select-input>
          <!--          <div style="height: 150px">-->
          <!--            <beacon id="beacon_generate" :size="100" cls="beacon" :value="beacon.interaction" />-->
          <!--          </div>-->
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full " label="Nome" />
          <textarea-input v-model="form.description" :error="form.errors.description"
                          class="pr-6 pb-8 w-full " label="Descrição"
          />
          <text-input v-model="form.code" :error="form.errors.code" class="pr-6 pb-8 w-full " label="Código" />
          URL:&nbsp;[<a :href="beacon.url" class="no-underline hover:underline"
                        target="_blank"
          >abrir</a>]<br /><br />
          <text-input v-model="form.url" :error="form.errors.url" placeholder="Ex.: https://www.google.com"
                      class="pr-6 pb-8 w-full "
          />
          <text-input v-model="form.coordinates" :error="form.errors.coordinates" class="pr-6 pb-8 w-full " label="Coordenadas" />
          <text-input v-model="form.imei" :error="form.errors.imei" class="pr-6 pb-8 w-full " label="IMEI" />
          <div class="pr-6 pb-8 w-full ">
            <label>Data Inicial:</label><br /><br />
            <datepicker v-model="form.start_date" :language="ptBR" :error="form.errors.start_date"
                        :format="customFormatter" placeholder="Selecione..."
            />
          </div>
          <div class="pr-6 pb-8 w-full ">
            <label>Data Final:</label><br /><br />
            <datepicker v-model="form.end_date" :language="ptBR" :error="form.errors.end_date"
                        :format="customFormatter" placeholder="Selecione..."
            />
          </div>
          <select-input v-model="form.active" :error="form.errors.active" class="pr-6 pb-8 w-full " label="Ativo">
            <option :value="null" />
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!beacon.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >
            Deletar beacon
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            Atualizar
            Beacon
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
.center {
    margin: auto;
    width: 50%;
    padding: 10px;
}
</style>
<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from 'vuejs-datepicker'
import TextareaInput from '@/Shared/TextareaInput'
import moment from 'moment'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo() {
    return {title: this.form.name}
  },
  components: {
    Datepicker,
    LoadingButton,
    TextInput,
    TrashedMessage,
    SelectInput,
    TextareaInput,
  },
  layout: Layout,
  props: {
    beacon: Object,
    organizations: Array,
    showOrganizations: Boolean,
  },
  remember: 'form',
  data() {
    return {
      output: null,
      ptBR: ptBR,
      form: this.$inertia.form({
        organization_id: this.beacon.organization_id,
        name: this.beacon.name,
        description: this.beacon.description,
        code: this.beacon.code,
        url: this.beacon.url,
        coordinates: this.beacon.coordinates,
        imei: this.beacon.imei,
        interaction: this.beacon.interaction,
        start_date: this.beacon.start_date,
        end_date: this.beacon.end_date,
        photo: null,
        photo_path: this.beacon.photo_path,
        phone: this.beacon.phone,
        state_id: this.beacon.state_id,
        city_id: this.beacon.city_id,
        state: null,
        active: this.beacon.active,
      }),
    }
  },
  methods: {
    customFormatter(date) {
      moment.locale('pt-br')
      return moment(date).format('L')
    },
    update() {
      this.form.put(this.route('beacons.update', this.beacon.id).url())
    },
    destroy() {
      if (confirm('Tem certeza de que deseja excluir este beacon?')) {
        this.$inertia.delete(this.route('beacons.destroy', this.beacon.id))
      }
    },
    restore() {
      if (confirm('Tem certeza de que deseja restaurar este beacon?')) {
        this.$inertia.put(this.route('beacons.restore', this.beacon.id))
      }
    },
  },
}
</script>
